import { ILogger } from "@dirootie-logging/logging-types";
import {
  NotificationSeverity,
  UserNotification,
  UserNotificationService,
} from "@dirootie-web/web-components-types";
import { toast } from "taltech-styleguide";
import { NotificationView } from "./NotificationView";

export class ReactToastifyUserNotificationService extends UserNotificationService {
  mapper = new Map<NotificationSeverity, (a: any, o?: any) => void>();
  public static inject = ["logger"] as const;
  constructor(logger: ILogger) {
    super(logger);
    this.mapper.set("error", toast.error);
    this.mapper.set("info", toast.info);
    this.mapper.set("success", toast.success);
    this.mapper.set("warning", toast.warn);
  }

  showNotification(
    severity: NotificationSeverity,
    notification: UserNotification
  ) {
    const f = this.mapper.get(severity)!;
    const notificationText = notification.title?.key
      ? notification.title?.key
      : notification.title;
    notification.className =
      notification.className || "ebd-toast-custom-styling";
    let content = notificationText;
    if (notification.component !== undefined) {
      content = (
        <NotificationView
          header={notificationText}
          content={<div>{notification.message}</div>}
        />
      );
    }
    f(content, notification);
  }
}
